import React, { useEffect, useState } from "react";
import { Announcement, Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { WhatYouGet, IntroVideo, BeforeAfter } from "../components/Sections";
import { VideoTestimonials, Reviews } from "../components/Reviews";
import {
  WhoWeAre,
  HowItWorks,
  TheTreatment,
  OfferCard,
} from "../components/About";
import { FaqSection } from "../components/FaqSection";
import { FinalCTA, Footer } from "../components/Footer";
import { ExitIntentPopup } from "../components/ExitIntentPopup";
import { SchedulingView } from "../components/SchedulingView";
import { CtaButton } from "../components/common";
import { OFFER, META_PIXEL_ID, DIRECT_BOOKING, GHL_CHAT_WIDGET_ID, BUSINESS } from "../mock";
import { initPixel, initAcuityPurchaseBridge } from "../lib/pixel";

const Landing = () => {
  const [booking, setBooking] = useState(null);
  const depositReturn = new URLSearchParams(window.location.search).get("deposit") === "1";
  useEffect(() => {
    document.title = `${BUSINESS.name} — ${OFFER.name}`;
    initPixel(META_PIXEL_ID);
    initAcuityPurchaseBridge({ fallbackValue: OFFER.price, currency: "USD" });
    // GoHighLevel chat widget (per-location)
    if (GHL_CHAT_WIDGET_ID && !document.getElementById("ghl-chat-widget")) {
      const s = document.createElement("script");
      s.id = "ghl-chat-widget";
      s.src = "https://widgets.leadconnectorhq.com/loader.js";
      s.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
      s.setAttribute("data-widget-id", GHL_CHAT_WIDGET_ID);
      s.setAttribute("data-source", "WEB_USER");
      document.body.appendChild(s);
    }
  }, []);

  if (depositReturn) {
    let saved = {};
    try { saved = JSON.parse(localStorage.getItem("db_active_lead") || "{}"); } catch (_) {}
    return <SchedulingView booking={saved} initialStage="deposit" onBack={() => (window.location.search = "")} />;
  }
  if (booking) {
    return <SchedulingView booking={booking} onBack={() => setBooking(null)} />;
  }

  return (
    <div className="min-h-screen bg-brand-ivory">
      <Announcement />
      <Header />
      <main>
        <Hero onComplete={setBooking} />
        <WhatYouGet />
        <IntroVideo />
        <BeforeAfter />
        <Reviews />
        <WhoWeAre />
        <HowItWorks />
        <TheTreatment />
        <OfferCard />
        <FaqSection />
        <FinalCTA />
      </main>
      <Footer />

      {/* Sticky booking / CTA bar */}
      <div
        data-testid="sticky-book-bar"
        className={`fixed inset-x-0 bottom-0 z-40 border-t border-brand-cream bg-brand-ivory/95 px-4 py-3 backdrop-blur-md ${DIRECT_BOOKING ? "" : "md:hidden"}`}
      >
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-3">
          <div>
            <p className="font-sans text-[11px] uppercase tracking-wider text-brand-muted">
              {DIRECT_BOOKING ? OFFER.name : "Intro Special"}
            </p>
            <p className="font-serif text-lg leading-none text-brand-ink">
              <span className="text-brand-muted line-through">${OFFER.regPrice}</span>{" "}
              <span className="text-brand-sage">${OFFER.price}</span>
            </p>
          </div>
          <CtaButton toForm size="sm" data-testid="sticky-book-btn" className="flex-shrink-0">
            {DIRECT_BOOKING ? "Book Now" : "Claim My Spot"}
          </CtaButton>
        </div>
      </div>
      <ExitIntentPopup />
    </div>
  );
};

export default Landing;
